import { parseHtmlString } from 'ingestion/nodeCreationHelpers'
import { IM360Parser } from '../../IM360Parser'
import { QuestionType } from 'shared/types/ingestion'
import { alphabetIndex } from '../../../../../utility'

const selectAllRegex = /Select\sall\s(?!(points|of\sthe\stranslations))/gm
export function parseSelectAll({
  title,
  statement,
  studentResponse,
}: {
  title?: string
  statement?: string
  studentResponse?: string
}) {
  if (!statement) return
  const asHtml = parseHtmlString(statement)
  if (!selectAllRegex.test(asHtml.body.textContent ?? '')) return
  const items = getSelections(asHtml)
  if (!items?.length) {
    return
    // throw new Error('SelectAll Items Not Found')
  }
  if (items.find((item) => item.textContent?.includes('Select all'))) {
    // What's happening here is the question is found within a list of questions
    // We will hopefully get to this question after the list of questions is split up
    return
  }
  const itemStrings = items.map((item) =>
    item.tagName.toLowerCase() === 'li' ? item.innerHTML : item.outerHTML,
  )
  return [
    IM360Parser.getInstance().createMultiAnswerQuestion({
      title,
      answers: itemOptions(itemStrings, studentResponse),
      description: asHtml.body.innerHTML,
      teacherNote: studentResponse,
      overrides: { type: QuestionType.MultipleSelect },
    }),
  ]
}

function getSelections(doc: Document) {
  const table =
    doc.getElementsByTagName('ol').item(0) ??
    doc.getElementsByTagName('ul').item(0)
  if (table) {
    table.remove()
    return Array.from(table.children).filter(
      (child) => child.tagName.toLowerCase() === 'li',
    )
  }
  const grid = doc.getElementsByClassName('imgrid').item(0)
  if (grid) {
    grid.remove()
    return Array.from(grid.getElementsByClassName('g--content'))
  }
}

function itemOptions(items: string[], answersString?: string) {
  const answers = attemptAnswersList(answersString)
  return items.map((description, index) => {
    const correct = answers
      ? answers.includes(index)
      : !!answersString?.includes(description)
    return { description, correct }
  })
}

function attemptAnswersList(answersString?: string) {
  if (!answersString || answersString.length > 250) return
  let cleaned: string | null | undefined =
    parseHtmlString(answersString).body.textContent
  cleaned = cleaned
    ?.toLowerCase()
    .split(/statements\s/)
    .pop()
  if (!cleaned) return
  cleaned = cleaned.split(/shapes\s/).pop()
  if (!cleaned) return
  cleaned = cleaned.split(/\sare true/)[0]
  cleaned = cleaned.split('.')[0]
  if (!cleaned) return
  return cleaned.split(/,?\sand\s*|,\s*/g).map((a) => {
    const asNum = Number(a)
    if (!isNaN(asNum)) return asNum - 1
    return alphabetIndex(a)
  })
}
